module.exports = __webpack_public_path__ + "img/g.645a8e18.svg";